/*!
 * (C) Ionic http://ionicframework.com - MIT License
 */
import { proxyCustomElement, HTMLElement, h, Host } from '@stencil/core/internal/client';
import { b as getIonMode } from './ionic-global.js';
const thumbnailCss = ":host{--size:48px;--border-radius:0;border-radius:var(--border-radius);display:block;width:var(--size);height:var(--size)}::slotted(ion-img),::slotted(img){border-radius:var(--border-radius);width:100%;height:100%;-o-object-fit:cover;object-fit:cover;overflow:hidden}";
const Thumbnail = /*@__PURE__*/proxyCustomElement(class Thumbnail extends HTMLElement {
  constructor(registerHost) {
    super();
    if (registerHost !== false) {
      this.__registerHost();
    }
    this.__attachShadow();
  }
  render() {
    return h(Host, {
      key: '70ada828e8cf541ab3b47f94b7e56ce34114ef88',
      class: getIonMode(this)
    }, h("slot", {
      key: 'c43e105669d2bae123619b616f3af8ca2f722d61'
    }));
  }
  static get style() {
    return thumbnailCss;
  }
}, [257, "ion-thumbnail"]);
function defineCustomElement$1() {
  if (typeof customElements === "undefined") {
    return;
  }
  const components = ["ion-thumbnail"];
  components.forEach(tagName => {
    switch (tagName) {
      case "ion-thumbnail":
        if (!customElements.get(tagName)) {
          customElements.define(tagName, Thumbnail);
        }
        break;
    }
  });
}
const IonThumbnail = Thumbnail;
const defineCustomElement = defineCustomElement$1;
export { IonThumbnail, defineCustomElement };